import { cn } from '@/lib/utils';
import { t } from '../i18n';

/** Пульсирующий блок на месте будущего контента. */
export function Skeleton({ className }: { className?: string }): JSX.Element {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} aria-hidden />;
}

/**
 * Скелетон списка: строки той же высоты, что реальные, чтобы при загрузке
 * не «прыгала» верстка.
 */
export function ListSkeleton({ rows = 4, className }: { rows?: number; className?: string }): JSX.Element {
  return (
    <div className={cn('panel mb-5 px-4', className)} role="status" aria-label={t('components.loading')}>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className={cn('flex items-center gap-3 py-3.5', index > 0 && 'border-t border-border')}>
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-3 w-1/3" />
          </div>
          <Skeleton className="h-4 w-16" />
        </div>
      ))}
    </div>
  );
}
